import { apiSlice } from "app/api/apiSlice"


export const hrSettingsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['hrSettings'],
    endpoints: builder => ({
        getHrSettings: builder.query({
            query: () => 'hr/settings',
            keepUnusedDataFor: 5,
            providesTags: ['hrSettings']
        }),
        setHrSettings: builder.mutation({
            query: data => ({
                url: 'hr/settings',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['hrSettings']
        })
    })
})

export const {
    useGetHrSettingsQuery,
    useLazyGetHrSettingsQuery,
    useSetHrSettingsMutation
} = hrSettingsApiSlice